// Only attach once
if (!window.updateButtonListenerAttached) {
  window.updateButtonListenerAttached = true;

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[id^='ProductUpdateButton-']");
    if (!btn) return;

    const modal = btn.closest(".quick-add-modal[open]") || document;
    const qtyInput = modal.querySelector("[name='quantity']");
    const variantId = btn.dataset.variantId;
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    btn.classList.add("loading");
    btn.setAttribute("disabled", "true");
    // Show spinner, hide text
    const btnSpinner = btn.querySelector(".loading__spinner");
    const btnText = btn.querySelector("span");
    if (btnSpinner) btnSpinner.classList.remove("hidden");
    if (btnText) btnText.style.visibility = "hidden";

    // get old variant id from hidden div

    let modalIsOpen = false;

    let variID = document.getElementById("old-variant-id");
    document.querySelectorAll(".quick-update-btn").forEach((radio) => {
      if (radio.hasAttribute("open")) {
        modalIsOpen = true;
        variID = radio.querySelector("#old-variant-id");
      }
    });

    const oldVariantDiv = modalIsOpen
      ? variID
      : document.getElementById("old-variant-id");

    const oldVariantId = oldVariantDiv
      ? oldVariantDiv.textContent.trim()
      : null;

    // helper function to update cart
    async function updateCart(data) {
      try {
        // 1. Fetch the current cart
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();

        // 2. Find the line of the variant you want to remove/update
        const lineItemIndex = cart.items.findIndex(
          (item) => item.variant_id == data.id
        );

        if (lineItemIndex === -1) {
          console.warn("Variant not found in cart:", data.id);
          return;
        }

        // Shopify line numbers start at 1
        const line = lineItemIndex + 1;

        // 3. Prepare payload with line number
        const payload = {
          line: line,
          quantity: data.quantity, // e.g., 0 to remove
          properties: {
            _unique_id: crypto.randomUUID()
          }
        };

        // 4. Call /cart/change.js
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        });

        const updatedCart = await res.json();
        return updatedCart;
      } catch (err) {
        console.error(err);
      }
    }

    // 1. Remove old variant if exists (decrement by 1, not remove all)
    let removePromise = Promise.resolve();
    if (oldVariantId) {
      removePromise = (async () => {
        // Fetch current cart to get the old variant's actual quantity
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();
        const lineItem = cart.items.find(item => item.variant_id == oldVariantId);
        if (lineItem) {
          const newQty = Math.max(0, lineItem.quantity - 1);
          return updateCart({ id: oldVariantId, quantity: newQty });
        }
      })();
    }

    // 2. Then add new variant as a new product
    removePromise
      .then(() =>
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: { _unique_id: crypto.randomUUID() } }),
        }).then((res) => res.json())
      )
      .then(async (cartItem) => {
        await updateCustomerCartMetafield();
        // refresh cart count
        // fetch("/cart.js")
        //   .then((res) => res.json())
        //   .then((cart) => {
        //     const cartCount = document.querySelector("[data-cart-count]");
        //     if (cartCount) cartCount.textContent = cart.item_count;
        //   });
        // ✅ close the modal
        if (modal && modal.classList.contains("quick-add-modal")) {
          if (typeof modal.close === "function") {
            modal.close(); // works if it's <dialog>
            window.location.reload();
          } else {
            modal.removeAttribute("open"); // works if it's custom div
            modal.classList.remove("open");
          }
        }

        // ✅ open cart drawer (same as clicking cart bubble)
        const cartBubble = document.getElementById("cart-icon-bubble");
        if (cartBubble) cartBubble.click();

        // ✅ refresh only <cart-drawer-items> content
        fetch("/cart?section_id=cart-drawer")
          .then((res) => res.text())
          .then((html) => {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;

            const newCartItems = tempDiv.querySelector("cart-drawer-items");
            const currentCartItems =
              document.querySelector("cart-drawer-items");

            if (newCartItems && currentCartItems) {
              currentCartItems.innerHTML = newCartItems.innerHTML;
            }

            // ✅ ensure cart drawer is visible
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
              cartDrawer.setAttribute("open", "");
            }
            window.location.reload();
            //  if (window.location.href.includes("cart")) {
            //   // Reload the page
            //   window.location.reload();
            // }
          });

        // Keep loading state — page will reload
      })
      .catch((err) => {
        console.error("Update failed:", err);
        btn.classList.remove("loading");
        btn.removeAttribute("disabled");
        if (btnSpinner) btnSpinner.classList.add("hidden");
        if (btnText) btnText.style.visibility = "visible";
      });
  });

  async function updateCustomerCartMetafield() {
    if (!window?.customer?.id) return; // Only run for logged-in users
    let currentCart = await fetch('/cart.js').then((res) => res.json());

const cartMetaData =
  typeof window.customer?.metafields?.cart?.itemsdata === "string"
    ? JSON.parse(window.customer.metafields.cart.itemsdata)
    : window.customer?.metafields?.cart?.itemsdata || {};
    if (currentCart?.items?.length === 0) return;

    const cartData = {
      items: currentCart?.items.map((item) => ({
        variant_id: item?.variant_id,
        quantity: item.quantity,
        properties: item.properties || {}, // line-item attributes
      })),
      attributes: currentCart.attributes || {}, // cart-level attributes
      note: currentCart.note || "",
    };

    const metaUpdateRes = await window.mapclubFetch('customer-cart-data', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId: window.customer?.id,
        cartData,
      }),
    });
    const data = await metaUpdateRes.json();
    if(data) {
      // ✅ Safely extract new metafield value
      const newItemsData = data?.metafield?.value
        ? data.metafield.value
        : window.customer?.metafields?.cart?.itemsdata;

      // ✅ If you need it locally (for logic or display)
      window.customer = {
        ...window.customer,
        metafields: {
          ...window.customer?.metafields,
          cart: {
            ...window.customer?.metafields?.cart,
            itemsdata: newItemsData,
          },
        },
      };
    }
  }
}
